export default __webpack_public_path__ + "static/media/microsoft-365.933f422f.svg";